var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiIconApi101Static = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "192px",
    viewBox: "0 0 240 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API101_static") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API101_static"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_Static"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9E8F6",
    strokeWidth: 12,
    fill: "#D9E8F6",
    x: 6,
    y: 6,
    width: 228,
    height: 180,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 15,
    y: 16,
    width: 210,
    height: 160
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2839307,72.5221841 L119.618864,92.1629952 L174.953796,72.5221841 C187.315013,85.8081941 194.865425,103.556561 194.865425,123.052466 C194.865425,124.299876 194.834515,125.540132 194.773412,126.772523 C192.817288,114.013165 159.917592,103.860731 119.618864,103.860731 C79.3201351,103.860731 46.4204394,114.013165 44.4643152,126.772523 C44.4032123,125.540132 44.3723021,124.299876 44.3723021,123.052466 C44.3723021,103.556561 51.9227144,85.8081941 64.2839308,72.5221841 Z",
    id: "Combined-Shape",
    fill: "#B49859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#B49859",
    points: "119.618864 0 239.237727 42.4580166 119.618864 84.9160332 7.36439969e-14 42.4580166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.055311,42.4580166 L44,62",
    id: "Line",
    stroke: "#003A5D",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(38.872302, 62.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19194106,0 L5.19194106,84.998259",
    id: "Line-2",
    stroke: "#003A5D",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#003A5D",
    cx: 5.19194106,
    cy: 17.6523318,
    rx: 5.19194106,
    ry: 7.35620441
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19194106,88.2718941 C8.05937092,88.2718941 10.3838821,84.9784092 10.3838821,80.9156897 C10.3838821,76.8529702 8.05937092,21.5434329 5.19194106,21.5434329 C2.32451119,21.5434329 -8.8817842e-16,76.8529702 -8.8817842e-16,80.9156897 C-8.8817842e-16,84.9784092 2.32451119,88.2718941 5.19194106,88.2718941 Z",
    id: "Oval-Copy",
    fill: "#003A5D"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiIconApi101Static);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/API_icon_API101_static.1f4ced1d92f0c5c4e3ebd267618f7b9e.svg";